import axios from 'axios'

export default {
  namespaced: true,
  state: {
    subjects: [],
    loading: false
  },
  mutations: {
    loading(state, value) {
      state.loading = value
    },
    subjects(state, value) {
      state.subjects = value
    }
  },
  actions: {
    fetchClassroomSubjects({commit, state}) {
      return new Promise((resolve, reject) => {
        commit('loading', true)
        axios.get('/subjects')
          .then((response) => {
            commit('subjects', response.data)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
          .finally(() => {
            commit('loading', false)
          })
      })
    },
    fetchSubject({commit, state}, id) {
      return axios.get('/subject/' + id)
        .then(({data}) => {
          return Promise.resolve(data)
        })

    }
  },
  getters: {
    subjects: state => state.subjects,
    loading: state => state.loading
  }
}
